import { STORAGE_KEYS } from "utils/constants";

const tokenService = {
    save(token, expiration) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);

        localStorage.setItem(STORAGE_KEYS.EXPIRATION, expiration);
    },

    getToken() {
        return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    },

    getExpiration() {
        return localStorage.getItem(STORAGE_KEYS.EXPIRATION);
    },

    clear() {
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);

        localStorage.removeItem(STORAGE_KEYS.EXPIRATION);
    }
};

export default tokenService;
